<template>
  <div
      v-loading="loading"
      class="containerInfo"
      element-loading-text="数据加载中……"
      element-loading-spinner="el-icon-loading"
  >
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div
              slot="header"
              class="clearfix"
              style="font-weight: bold; display: flex; align-items: center"
          >
            <img
                src="@/assets/recruit/juxing.png"
                alt="Logo"
                style="margin-right: 12px"
            /><span><b>基本情况</b> </span>
            <!--            <span v-if="isProfessionTech || isTechnique" style="float: right"-->
            <!--              >(*为必填项，投递时上传附件中包含的信息可以不填，有留学经历的在国(境)外留学情况选择:是)</span-->
            <!--            >-->
          </div>
          <div class="tip-class">
            温馨提示：*为必填项；有留学经历的在国(境)外留学情况选择:是；国籍，民族，毕业单位，毕业专业:等信息可在下拉选择框进行搜索后选择。
          </div>
          <el-form
              ref="postForm"
              :model="form"
              :rules="rules"
              label-width="100px"
          >
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="姓名:" prop="name">
                  <el-col :span="10">
                    <el-input
                        v-model="form.name"
                        placeholder="姓名"
                        maxlength="15"
                        style="width: 350px"
                        :readonly="isView"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号:" prop="cardNumber">
                  <el-col :span="10"
                  ><el-input
                      v-model="form.cardNumber"
                      maxlength="20"
                      placeholder="身份证号"
                      style="width: 350px"
                      :readonly="isView"
                      @blur="readCardNumber"
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item
                    label="注册手机号:"
                    prop="mobile"
                    :required="isRequired"
                >
                  <el-col :span="10">
                    <el-input
                        v-model="form.mobile"
                        onkeyup="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                        placeholder="输入注册时的手机号，否则账号的手机号将被修改"
                        readonly
                        disabled
                        style="width: 350px"
                        clearable
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别:" prop="sex">
                  <el-col :span="10"
                  ><zr-combobox
                      v-model="form.sex"
                      :data-array="[
                        { name: '男', code: 'male' },
                        { name: '女', code: 'female' },
                      ]"
                      :readonly="isView"
                      value-field="code"
                      label-field="name"
                      style="width: 350px"
                  ></zr-combobox
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="出生年月日:" prop="birthday">
                  <el-col :span="10">
                    <el-date-picker
                        v-model="form.birthday"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :readonly="isView"
                        placeholder="选择出生年月日"
                        style="width: 350px"
                        @change="birthdayDateChange"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱:" prop="email">
                  <el-col :span="10"
                  ><el-input
                      v-model="form.email"
                      maxlength="30"
                      placeholder="邮箱"
                      clearable
                      style="width: 350px"
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="国籍:" prop="nationality">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.nationality"
                        :data-array="basicNationality"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                        filterable
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="民族:" prop="nation">
                  <el-col :span="10"
                  ><zr-combobox
                      v-model="form.nation"
                      :data-array="nationArray"
                      value-field="code"
                      label-field="name"
                      style="width: 350px"
                      filterable
                  ></zr-combobox
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="政治面貌:" prop="politicallyState">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.politicallyState"
                        :data-array="basicPoliticallyState"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="籍贯:" prop="birthdayLocal">
                  <el-col :span="20">
                    <el-cascader
                        v-model="form.birthdayLocal"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择籍贯"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="出生地:" prop="placeOfOrigin">
                  <el-col :span="20">
<!--                    <LazyCascaderNew-->
<!--                        v-model="form.placeOfOrigin"-->
<!--                        :max-level="2"-->
<!--                        placeholder="请选择出生地"-->
<!--                    />-->
                    <el-cascader
                        v-model="form.placeOfOrigin"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择出生地"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="高考时户籍所在地:" prop="nativePlace">
                  <el-col :span="20">
<!--                    <LazyCascader-->
<!--                        v-model="form.nativePlace"-->
<!--                        :max-level="2"-->
<!--                        placeholder="请选择高考时户籍所在地"-->
<!--                    />-->
                    <el-cascader
                        v-model="form.nativePlace"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择高考时户籍所在地"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="婚否:" prop="married">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.married"
                        :data-array="[
                        { name: '已婚', code: 1 },
                        { name: '未婚', code: 0 },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 350px"
                        @change="onMarriedChange"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                    label="配偶国籍:"
                    prop="spouseNationality"
                    :required="isMarriedRequired"
                >
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.spouseNationality"
                        :data-array="basicNationality"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                        filterable
                        clearable
                    ></zr-combobox
                    ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="国(境)外留学情况:" prop="hasBroadExp">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.hasBroadExp"
                        placeholder="有海外关系或工作学习经历"
                        clearable
                        :data-array="[
                        { name: '是', code: 1 },
                        { name: '否', code: 0 },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 350px"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身高(cm):" prop="high">
                  <el-col :span="10"
                  ><el-input-number
                      v-model="form.high"
                      placeholder="身高(cm)"
                      size="mini"
                      :min="0"
                      :precision="0"
                      :step="1"
                      clearable
                      style="width: 350px"
                  ></el-input-number
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!isMb">
              <el-col :span="12">
                <el-form-item label="体重(kg):" prop="weight">
                  <el-col :span="10">
                    <el-input-number
                        v-model="form.weight"
                        placeholder="体重(kg)"
                        size="mini"
                        :min="0"
                        :precision="0"
                        :step="1"
                        style="width: 350px"
                        clearable
                    ></el-input-number>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <!--手机端-->
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="姓名:" prop="name">
                  <el-col :span="10">
                    <el-input
                        v-model="form.name"
                        placeholder="姓名"
                        maxlength="15"
                        style="width: 350px"
                        :readonly="isView"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="身份证号:" prop="cardNumber">
                  <el-col :span="10"
                  ><el-input
                      v-model="form.cardNumber"
                      maxlength="20"
                      placeholder="身份证号"
                      style="width: 350px"
                      :readonly="isView"
                      @blur="readCardNumber"
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item
                    label="注册手机号:"
                    prop="mobile"
                    :required="isRequired"
                >
                  <el-col :span="10">
                    <el-input
                        v-model="form.mobile"
                        onkeyup="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                        placeholder="输入注册时的手机号，否则账号的手机号将被修改"
                        readonly
                        disabled
                        style="width: 350px"
                        clearable
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="性别:" prop="sex">
                  <el-col :span="10"
                  ><zr-combobox
                      v-model="form.sex"
                      :data-array="[
                        { name: '男', code: 'male' },
                        { name: '女', code: 'female' },
                      ]"
                      :readonly="isView"
                      value-field="code"
                      label-field="name"
                      style="width: 350px"
                  ></zr-combobox
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="出生年月日:" prop="birthday">
                  <el-col :span="10">
                    <el-date-picker
                        v-model="form.birthday"
                        align="right"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :readonly="isView"
                        placeholder="选择出生年月日"
                        style="width: 350px"
                        @change="birthdayDateChange"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="邮箱:" prop="email">
                  <el-col :span="10"
                  ><el-input
                      v-model="form.email"
                      maxlength="30"
                      placeholder="邮箱"
                      clearable
                      style="width: 350px"
                  ></el-input
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="国籍:" prop="nationality">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.nationality"
                        :data-array="basicNationality"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                        filterable
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="民族:" prop="nation">
                  <el-col :span="10"
                  ><zr-combobox
                      v-model="form.nation"
                      :data-array="nationArray"
                      value-field="code"
                      label-field="name"
                      style="width: 350px"
                      filterable
                  ></zr-combobox
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="政治面貌:" prop="politicallyState">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.politicallyState"
                        :data-array="basicPoliticallyState"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="20">
                <el-form-item label="籍贯:" prop="birthdayLocal">
                  <el-col :span="20">
                    <!--                    <el-cascader-->
                    <!--                        v-model="form.birthdayLocal"-->
                    <!--                        :options="basicBirthdayLocal"-->
                    <!--                        :show-all-levels="false"-->
                    <!--                        :props="{-->
                    <!--                        label: 'name',-->
                    <!--                        value: 'code',-->
                    <!--                        children: 'children',-->
                    <!--                      }"-->
                    <!--                        filterable-->
                    <!--                    ></el-cascader>-->
<!--                    <LazyCascader-->
<!--                        v-model="form.birthdayLocal"-->
<!--                        :max-level="2"-->
<!--                        placeholder="请选择籍贯"-->
<!--                    />-->
                    <el-cascader
                        v-model="form.birthdayLocal"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择籍贯"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="20">
                <el-form-item label="出生地:" prop="placeOfOrigin">
                  <el-col :span="20">
                    <!--                    <el-cascader-->
                    <!--                        v-model="form.placeOfOrigin"-->
                    <!--                        :options="basicBirthdayLocal"-->
                    <!--                        :show-all-levels="false"-->
                    <!--                        :props="{-->
                    <!--                        label: 'name',-->
                    <!--                        value: 'code',-->
                    <!--                        children: 'children',-->
                    <!--                      }"-->
                    <!--                        filterable-->
                    <!--                    ></el-cascader>-->
<!--                    <LazyCascaderNew-->
<!--                        v-model="form.placeOfOrigin"-->
<!--                        :max-level="2"-->
<!--                        placeholder="请选择出生地"-->
<!--                    />-->
                    <el-cascader
                        v-model="form.placeOfOrigin"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择出生地"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="20">
                <el-form-item label="高考时户籍所在地:" prop="nativePlace">
                  <el-col :span="20">
                    <!--                    <el-cascader-->
                    <!--                        v-model="form.nativePlace"-->
                    <!--                        :options="basicBirthdayLocal"-->
                    <!--                        :show-all-levels="false"-->
                    <!--                        :props="{-->
                    <!--                        label: 'name',-->
                    <!--                        value: 'code',-->
                    <!--                        children: 'children',-->
                    <!--                      }"-->
                    <!--                        filterable-->
                    <!--                    ></el-cascader>-->
<!--                    <LazyCascader-->
<!--                        v-model="form.nativePlace"-->
<!--                        :max-level="2"-->
<!--                        placeholder="请选择高考时户籍所在地"-->
<!--                    />-->
                    <el-cascader
                        v-model="form.nativePlace"
                        :options="areaOptions"
                        :props="cascaderProps"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择高考时户籍所在地"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="婚否:" prop="married">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.married"
                        :data-array="[
                        { name: '已婚', code: 1 },
                        { name: '未婚', code: 0 },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 350px"
                        @change="onMarriedChange"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item
                    label="配偶国籍:"
                    prop="spouseNationality"
                    :required="isMarriedRequired"
                >
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.spouseNationality"
                        :data-array="basicNationality"
                        value-field="code"
                        label-field="name"
                        :readonly="isView"
                        style="width: 350px"
                        filterable
                        clearable
                    ></zr-combobox
                    ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="国(境)外留学情况:" prop="hasBroadExp">
                  <el-col :span="10">
                    <zr-combobox
                        v-model="form.hasBroadExp"
                        placeholder="有海外关系或工作学习经历"
                        clearable
                        :data-array="[
                        { name: '是', code: 1 },
                        { name: '否', code: 0 },
                      ]"
                        value-field="code"
                        label-field="name"
                        style="width: 350px"
                    ></zr-combobox>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="身高(cm):" prop="high">
                  <el-col :span="10"
                  ><el-input-number
                      v-model="form.high"
                      placeholder="身高(cm)"
                      size="mini"
                      :min="0"
                      :precision="0"
                      :step="1"
                      clearable
                      style="width: 350px"
                  ></el-input-number
                  ></el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-col :span="12">
                <el-form-item label="体重(kg):" prop="weight">
                  <el-col :span="10">
                    <el-input-number
                        v-model="form.weight"
                        placeholder="体重(kg)"
                        size="mini"
                        :min="0"
                        :precision="0"
                        :step="1"
                        style="width: 350px"
                        clearable
                    ></el-input-number>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="特长:" prop="speciality">
              <el-col :span="16"
              ><el-input
                  v-model="form.speciality"
                  maxlength="30"
                  placeholder="特长"
                  clearable
              ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item label="爱好:" prop="hobby">
              <el-col :span="16"
              ><el-input
                  v-model="form.hobby"
                  maxlength="30"
                  placeholder="爱好"
                  clearable
              ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item label="头像(1MB以内png格式):">
              <el-col :span="6">
                <el-row>
                  <el-upload
                      title="照片上传"
                      class="avatar-uploader"
                      :headers="headers"
                      :action="pictureUploadAction"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" style="object-fit: contain;"/>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-row>
              </el-col>
            </el-form-item>
            <!--            <div style="margin-bottom: 10px">-->
            <!--              <el-row>-->
            <!--                <el-col :span="20"-->
            <!--                  ><span class="spanTitle"-->
            <!--                    >家庭成员:-->
            <!--                    <el-button-->
            <!--                      style="border: 1px solid #1890ff; margin-left: 10px"-->
            <!--                      @click="addFamilyMember"-->
            <!--                      ><i class="el-icon-plus" style="color: #1890ff"-->
            <!--                        ><a style="color: #1890ff">添加家庭成员</a></i-->
            <!--                      ></el-button-->
            <!--                    ></span-->
            <!--                  >-->
            <!--                </el-col>-->
            <!--              </el-row>-->
            <!--            </div>-->
            <!--            <el-card>-->
            <!--              <div style="overflow: auto; height: 360px">-->
            <!--                <zr-table-->
            <!--                  ref="familyTable"-->
            <!--                  height-fixed-->
            <!--                  class="user-box"-->
            <!--                  selection-type="single"-->
            <!--                  :data="form.familyInfo"-->
            <!--                  :columns="familyColumns"-->
            <!--                  table-height="300px"-->
            <!--                  style="overflow: auto"-->
            <!--                  stripe-->
            <!--                  @row-click="familyClick"-->
            <!--                >-->
            <!--                  <template v-slot:relationship="{ row }">-->
            <!--                    <el-select v-model="row['relationship']">-->
            <!--                      <el-option-->
            <!--                        v-for="item in basicFamily"-->
            <!--                        :key="item.code"-->
            <!--                        :label="item.name"-->
            <!--                        :value="item.code"-->
            <!--                      >-->
            <!--                      </el-option>-->
            <!--                    </el-select>-->
            <!--                  </template>-->
            <!--                  <template v-slot:name="{ row }">-->
            <!--                    <el-input-->
            <!--                      v-model="row['name']"-->
            <!--                      size="mini"-->
            <!--                      maxlength="10"-->
            <!--                    ></el-input>-->
            <!--                  </template>-->
            <!--                  <template v-slot:sex="{ row }">-->
            <!--                    <el-select v-model="row['sex']">-->
            <!--                      <el-option-->
            <!--                        v-for="item in basicSex"-->
            <!--                        :key="item.code"-->
            <!--                        :label="item.name"-->
            <!--                        :value="item.code"-->
            <!--                      >-->
            <!--                      </el-option>-->
            <!--                    </el-select>-->
            <!--                  </template>-->
            <!--                  <template v-slot:birthDay="{ row }">-->
            <!--                    <el-date-picker-->
            <!--                      v-model="row['birthDay']"-->
            <!--                      type="date"-->
            <!--                      placeholder="选择出生日期"-->
            <!--                    >-->
            <!--                    </el-date-picker>-->
            <!--                  </template>-->
            <!--                  <template v-slot:nation="{ row }">-->
            <!--                    <el-select v-model="row['nation']" clearable filterable>-->
            <!--                      <el-option-->
            <!--                        v-for="item in nationArray"-->
            <!--                        :key="item.code"-->
            <!--                        :label="item.name"-->
            <!--                        :value="item.code"-->
            <!--                      >-->
            <!--                      </el-option>-->
            <!--                    </el-select>-->
            <!--                  </template>-->
            <!--                  <template v-slot:politicallyState="{ row }">-->
            <!--                    <el-select-->
            <!--                      v-model="row['politicallyState']"-->
            <!--                      clearable-->
            <!--                      filterable-->
            <!--                    >-->
            <!--                      <el-option-->
            <!--                        v-for="item in basicPoliticallyState"-->
            <!--                        :key="item.code"-->
            <!--                        :label="item.name"-->
            <!--                        :value="item.code"-->
            <!--                      >-->
            <!--                      </el-option>-->
            <!--                    </el-select>-->
            <!--                  </template>-->
            <!--                  <template v-slot:deptAndHeadship="{ row }">-->
            <!--                    <el-input-->
            <!--                      v-model="row['deptAndHeadship']"-->
            <!--                      size="mini"-->
            <!--                      maxlength="500"-->
            <!--                      clearable-->
            <!--                      @focus="openContentDialog(row)"-->
            <!--                    ></el-input>-->
            <!--                  </template>-->
            <!--                  <template v-slot:operate="{ row }">-->
            <!--                    <el-button type="text" @click="delFamily(row)"-->
            <!--                      >删除</el-button-->
            <!--                    >-->
            <!--                  </template>-->
            <!--                </zr-table>-->
            <!--              </div>-->
            <!--            </el-card>-->
            <el-row type="flex" justify="space-around">
              <el-col :lg="24" :sm="24" :xs="24">
                <el-card class="box-card">
                  <el-form ref="postForm" :model="form" label-position="top">
                    <div>
                      <div style="margin-bottom: 10px">
                        <el-row>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="是否有家庭成员:"
                                prop="hasFamily"
                                :required="true"
                            >
                              <zr-combobox
                                  v-model="form.hasFamily"
                                  placeholder="是否有家庭成员"
                                  :data-array="[
                                  { name: '是', code: '是' },
                                  { name: '否', code: '否' },
                                ]"
                                  value-field="code"
                                  label-field="name"
                                  style="width: 135px"
                                  @change="hasFamilyChange"
                              ></zr-combobox>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row v-if="(isProfessionTech || isTechnique)&&
                    isPost">
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="是否与应聘单位干部职工存在亲属关系:"
                                prop="deptRelation"
                                :required="true"
                            >  <i class="el-icon-question" style="color: red;cursor: pointer" @click="showContent()"></i>
                              <zr-combobox
                                  v-model="form.deptRelation"
                                  placeholder="是否与应聘单位干部职工存在亲属关系"
                                  :data-array="[
                                  { name: '是', code: '是' },
                                  { name: '否', code: '否' },
                                ]"
                                  value-field="code"
                                  label-field="name"
                                  style="width: 135px"
                              ></zr-combobox>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="是否与院内干部职工存在亲属关系:"
                                prop="yardRelations"
                                :required="true"
                            >  <i class="el-icon-question" style="color: red;cursor: pointer" @click="showContent()"></i>
                              <zr-combobox
                                  v-model="form.yardRelations"
                                  placeholder="是否与院内干部职工存在亲属关系"
                                  :data-array="[
                                  { name: '是', code: '是' },
                                  { name: '否', code: '否' },
                                ]"
                                  value-field="code"
                                  label-field="name"
                                  style="width: 135px"
                              ></zr-combobox>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col
                              v-if="showAddButton"
                              :lg="8"
                              :sm="24"
                              :xs="24"
                          >
                            <span class="spanTitle"
                            >家庭成员:
                              <el-button
                                  style="
                                  border: 1px solid #1890ff;
                                  margin-left: 10px;
                                "
                                  @click="addFamilyMember"
                              ><i class="el-icon-plus" style="color: #1890ff"
                              ><a style="color: #1890ff">添加家庭成员</a></i
                              ></el-button
                              ></span
                            >
                          </el-col>
                        </el-row>
                      </div>
                      <el-card
                          v-for="row in form.familyInfo"
                          :key="row.id"
                          style="background-color: #f5f7fa"
                      >
                        <div slot="header">
                          <el-button
                              style="float: right; padding: 3px 0"
                              icon="el-icon-minus"
                              type="text"
                              @click="delFamily(row)"
                          >删除</el-button
                          >
                        </div>
                        <el-row>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="与本人关系:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-select v-model="row['relationship']">
                                <el-option
                                    v-for="item in basicFamily"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="性别:"
                                prop="sex"
                                label-width="100px"
                                :required="true"
                            >
                              <el-select v-model="row['sex']">
                                <el-option
                                    v-for="item in basicSex"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="姓名:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-input
                                  v-model="row['name']"
                                  maxlength="10"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="出生日期:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-date-picker
                                  v-model="row['birthDay']"
                                  type="date"
                                  placeholder="选择出生日期"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="民族:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-select
                                  v-model="row['nation']"
                                  clearable
                                  filterable
                              >
                                <el-option
                                    v-for="item in nationArray"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :lg="8" :sm="24" :xs="24">
                            <el-form-item
                                label="政治面貌:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-select
                                  v-model="row['politicallyState']"
                                  clearable
                                  filterable
                              >
                                <el-option
                                    v-for="item in basicPoliticallyState"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :lg="24" :sm="24" :xs="24" :required="true">
                            <el-form-item
                                label="单位名称:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-col :span="17">
                                <el-input
                                    v-model="row['deptAndHeadship']"
                                    size="mini"
                                    maxlength="500"
                                    clearable
                                ></el-input>
                              </el-col>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :lg="24" :sm="24" :xs="24" :required="true">
                            <el-form-item
                                label="职务:"
                                label-width="100px"
                                :required="true"
                            >
                              <el-col :span="17">
                                <el-input
                                    v-model="row['workInfo']"
                                    size="mini"
                                    maxlength="500"
                                    clearable
                                ></el-input>
                              </el-col>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-card>
                    </div>
                  </el-form>
                </el-card>
              </el-col>
            </el-row>
            <div style="text-align: center">
              <slot name="footBtn" :form="form">
                <!--                  <el-button icon="el-icon-circle-check">保存</el-button>-->
                <el-button
                    v-if="isTechnique || isProfessionTech"
                    icon="el-icon-circle-check"
                    type="primary"
                    @click="nextActice"
                >下一步</el-button
                >
                <el-button icon="el-icon-back" plain @click="back"
                >返回</el-button
                >
                <el-button
                    v-if="!isTechnique && !isProfessionTech"
                    icon="el-icon-circle-check"
                    type="primary"
                    @click="doSave"
                >保存</el-button
                >
              </slot>
            </div>
          </el-form>
        </el-card>
      </el-col></el-row
    >
    <show-archive-type ref="showArc"></show-archive-type>
  </div>
</template>
<script>
import { isEmail, isIdCard } from "zr-util/src/utils/comm/validate";
import { mapGetters } from "vuex";
import isMobile from "@/utils/device";
import {getBasicData,getBasicDataBatch} from "@/api/job/postInfo";
import settingHelp from "@/config/localSetting";
import store from "@/store";
import { messageDuration } from "@/config/settings";
import { saveResumeInfo } from "@api/recruit/user/resume";
import showArchiveType from "^/zr/dialog/showArchiveType.vue";
import areaData from '@/assets/json/area.json'

const config = settingHelp.getConfig();
const { remoteURL } = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;

export default {
  name: "PersonalBasicInfo",
  components: { showArchiveType},
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    isPost: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isTechnique: {
      type: Boolean,
      default: false,
    },
    isProfessionTech: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAddButton: true,
      pictureUploadAction: "", // 照片上传地址
      imageUrl: "",
      headers: { Authorization: token },
      basicNationality: [], //国籍数据字典
      basicPoliticallyState: [], //政治面貌数据字典
      basicBirthdayLocal: [], //籍贯数据字典
      basicFamily: [], //家庭成员关系数据字典
      isMb: false, // 是否是移动设备
      // isRequired: true, //学生编辑模式
      // isView: false, // 管理员查看模式
      // isTechnique: false, // 技能类
      // isProfessionTech: false, // 专技类
      isMarriedRequired: false,
      nationArray: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [
          { required: true, message: "请输入出生年月", trigger: "blur" },
        ],
        cardNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        politicallyState: [
          { required: true, message: "请选择政治面貌", trigger: "blur" },
        ],
        birthdayLocal: [
          { required: true, message: "请选择籍贯", trigger: "blur" },
        ],
        placeOfOrigin: [
          { required: true, message: "请选择出生地", trigger: "blur" },
        ],
        nativePlace: [
          {
            required: true,
            message: "请选择高考时户籍所在地",
            trigger: "blur",
          },
        ],
        nationality: [
          { required: true, message: "请选择国籍", trigger: "blur" },
        ],
        nation: [{ required: true, message: "请选择民族", trigger: "blur" }],
        hasBroadExp: [
          {
            required: true,
            message: "请输入国(境)外留学情况",
            trigger: "blur",
          },
        ],
        married: [
          { required: true, message: "请选择婚姻状况", trigger: "blur" },
        ],
      },
      familyColumns: [
        {
          name: "与本人关系",
          code: "relationship",
          needDrawCell: true,
          width: "120",
        },
        { name: "姓名", code: "name", needDrawCell: true, width: "80" },
        { name: "性别", code: "sex", needDrawCell: true, width: "80" },
        {
          name: "出生日期",
          code: "birthDay",
          needDrawCell: true,
          width: "120",
        },
        { name: "民族", code: "nation", needDrawCell: true, width: "120" },
        {
          name: "政治面貌",
          code: "politicallyState",
          needDrawCell: true,
          width: "160",
        },
        { name: "单位名称", code: "deptAndHeadship", needDrawCell: true },
        { name: "职务", code: "workInfo", needDrawCell: true },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      basicSex: [
        { name: "男", code: "male" },
        { name: "女", code: "female" },
      ],
      curI: null,
      loading: false,
      areaOptions: areaData,
      cascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        isLeaf: 'isLeaf'
      }
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
  },
  async created() {
    console.log("this.isProfessionTech",this.isProfessionTech);
    console.log("this.isTechnique",this.isTechnique);
    this.loading = true;
    // 判断是否是移动设备
    this.isMb = await isMobile();
    // 路由参数 判断页面状态
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    // 数据字典 1005修改
    // await this.getNationalityArray();
    // await this.getPoliticallyArray();
    // await this.getFamilyArray();
    // await this.getNationArray();
    await this.loadBasicArray()
    this.pictureUploadAction =
        remoteURL + "/comm/file/uploadPicture?resumeId=" + this.form.id; // 照片上传加上url简历id
    if (this.form.postSendId) this.postSendId = this.form.postSendId;
    // if (this.form.isProfessionTech)
    //   this.isProfessionTech = this.form.isProfessionTech;
    // if (this.form.isTechnique) this.isTechnique = this.form.isTechnique;
    if (this.form.employeePic)
      this.imageUrl =
          remoteURL + "/comm/file/downloadPicture?resumeId=" + this.form.id; // 照片加载url简历id
    if (!this.form.sex || !this.form.birthday) {
      this.readCardNumber();
    }
    if (this.form.hasFamily === "是") {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }
    this.loading = false;
    this.$emit("onLoad", false);
  },
  methods: {
    childDataCheck() {
      let data = this.form;
      let name = data.name;
      if (!name) {
        this.$message.warning("请填写 [姓名]！");
        return false;
      }
      let sex = data.sex;
      if (!sex) {
        this.$message.warning("请填写 [性别]！");
        return false;
      }
      let mobile = data.mobile;
      if (!mobile) {
        this.$message.warning("请填写 [手机号码]！");
        return false;
      }
      let birthday = data.birthday;
      if (!birthday) {
        this.$message.warning("请填写 [出生年月日]！");
        return false;
      }
      let email = data.email;
      if (!email) {
        this.$message.warning("请填写 [邮箱]！");
        return false;
      } else if (!isEmail(email)) {
        this.$message.warning("请填写正确格式的 [邮箱]！");
        return false;
      }
      let cardNumber = data.cardNumber;
      if (!cardNumber) {
        this.$message.warning("请填写 [身份证号]！");
        return false;
      } else if (!isIdCard(cardNumber)) {
        this.$message.warning("请填写正确格式的 [身份证号]！");
        return false;
      }
      //修改1005
      let politicallyState = data.politicallyState;
      if (!politicallyState || politicallyState.trim() === "") {
        this.$message.warning("请填写 [政治面貌]！");
        return false;
      }
      let birthdayLocal = data.birthdayLocal;
      if (!birthdayLocal || birthdayLocal.length === 0) {
        this.$message.warning("请填写 [籍贯]！");
        return false;
      }
      let placeOfOrigin = data.placeOfOrigin;
      if (!placeOfOrigin || placeOfOrigin.length === 0) {
        this.$message.warning("请填写 [出生地]！");
        return false;
      }
      let nativePlace = data.nativePlace;
      if (!nativePlace || nativePlace.length === 0) {
        this.$message.warning("请填写 [高考时户籍所在地]！");
        return false;
      }
      let nation = data.nation;
      if (!nation || nation.trim() === "") {
        this.$message.warning("请填写 [民族]！");
        return false;
      }
      let married = data.married;
      if (!married && married !== 0) {
        this.$message.warning("请填写 [婚否]！");
        return false;
      }
      if (this.isMarriedRequired) {
        let spouseNationality = data.spouseNationality;
        if (!spouseNationality && spouseNationality === "") {
          this.$message.warning("请填写 [配偶国籍]！");
          return false;
        }
      }
      let nationality = data.nationality;
      if (!nationality || nationality.trim() === "") {
        this.$message.warning("请填写 [国籍]！");
        return false;
      }
      if (data.hasFamily === "是" && data.familyInfo.length === 0) {
        this.$message.warning("家庭成员不能为空！");
        return false;
      }
      if (data.yardRelations === "是" && data.familyInfo.length === 0) {
        this.$message.warning("请勾选是否有家庭成员，并填写家庭成员信息！");
        return false;
      }
      if (data.deptRelation === "是" && data.familyInfo.length === 0) {
        this.$message.warning("请勾选是否有家庭成员，并填写家庭成员信息！");
        return false;
      }
      for (let i = 0; i < data.familyInfo.length; i++) {
        let familyInfo = data.familyInfo[i];
        if (!familyInfo.relationship || familyInfo.relationship === "") {
          this.$message.warning("家庭成员与本人关系不能为空！");
          return false;
        }
        if (!familyInfo.name || familyInfo.name === "") {
          this.$message.warning("家庭成员姓名不能为空！");
          return false;
        }
        if (!familyInfo.sex || familyInfo.sex === "") {
          this.$message.warning("家庭成员性别不能为空！");
          return false;
        }
        if (!familyInfo.birthDay || familyInfo.birthDay === "") {
          this.$message.warning("家庭成员出生日期不能为空！");
          return false;
        }
        if (!familyInfo.nation || familyInfo.nation === "") {
          this.$message.warning("家庭成员民族不能为空！");
          return false;
        }
        if (
            !familyInfo.politicallyState ||
            familyInfo.politicallyState === ""
        ) {
          this.$message.warning("家庭成员政治面貌不能为空！");
          return false;
        }
        if (!familyInfo.deptAndHeadship || familyInfo.deptAndHeadship === "") {
          this.$message.warning("家庭成员单位及其职务不能为空！");
          return false;
        }
      }
      return true;
    },
    back() {
      this.$router.back();
    },
    nextActice() {
      this.$refs.postForm.validate(async (valid) => {
        if (!valid) return;
        if (!this.childDataCheck()) {
          return;
        }
        this.$emit("nextActice");
      });
    },
    onMarriedChange(e) {
      if (e === 1) {
        this.isMarriedRequired = true;
      } else {
        this.isMarriedRequired = false;
      }
    },
    async loadBasicArray(){
      var  result = await getBasicDataBatch({typeCodeList:"nationality,politicallyState,basicFamily,nation"})
      if (result.success) {
        this.basicNationality = result.data.nationality;
        this.basicPoliticallyState = result.data.politicallyState;
        this.basicFamily = result.data.basicFamily;
        this.nationArray = result.data.nation;
      }else {
        this.$message.error(result.message);
      }
    },
    //国籍 1005
    async getNationalityArray() {
      let res = await getBasicData({ typeCode: "nationality" });
      if (res.success) {
        this.basicNationality = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //政治面貌 1005
    async getPoliticallyArray() {
      let res = await getBasicData({ typeCode: "politicallyState" });
      if (res.success) {
        this.basicPoliticallyState = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //籍贯 1005
    async getBirthLocalArray() {
      let res = await getBasicData({ typeCode: "birthdayLocal" });
      if (res.success) {
        let data = res.data;
        this.basicBirthdayLocal = this.bulidTreeData(data);
      } else {
        this.$message.error(res.message);
      }
    },
    /**
     * 构建树形数据
     * @param data
     * @param parentId
     * @returns 数据
     */
    bulidTreeData(data, rootParentId = "") {
      const tree = [];
      data.forEach((item) => {
        if (item.parentId === rootParentId) {
          const children = this.bulidTreeData(data, item.id);
          if (children.length && children.length > 0) {
            item.children = children;
          }
          tree.push(item);
        }
      });
      return tree;
      // const map = new Map();
      // const tree = [];
      // data.forEach((item) => {
      //   map.set(item.id, { ...item, children: [] });
      // });
      // console.log("map内容",Array.from(map.entries()));
      // data.forEach((item) => {
      //   const node = map.get(item.id);
      //   const parentId = map.get(item.parentId);
      //   console.log(`处理节点${node.name}`)
      //   if (parentId === rootParentId) {
      //     tree.push(node);
      //     console.log("->加入根节点")
      //   } else {
      //     const parent = map.get(item.parentId);
      //     console.log(`->成为父节点${parent.name}`)
      //     if (parent) {
      //       //parent.children.push(node);
      //       console.log("->丢弃")
      //     }
      //   }
      // });
    },
    //家庭成员关系
    async getFamilyArray() {
      let res = await getBasicData({ typeCode: "basicFamily" });
      if (res.success) {
        this.basicFamily = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 民族
    async getNationArray() {
      let res = await getBasicData({ typeCode: "nation" });
      if (res.success) {
        this.nationArray = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png 格式!");
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isJPG && isLt1M;
    },
    // 照片加载
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 身份证识别
    readCardNumber() {
      let cardNumber = this.form.cardNumber;
      if (!cardNumber) {
        this.$message.warning("请填写 [身份证号]！");
      } else if (!isIdCard(cardNumber)) {
        this.$message.warning("请填写正确格式的 [身份证号]！");
      } else {
        // --- 身份证号识别
        // 设置出生年月日
        this.form.birthday =
            cardNumber.substring(6, 10) +
            "-" +
            cardNumber.substring(10, 12) +
            "-" +
            cardNumber.substring(12, 14);
        // 设置性别
        this.form.sex =
            parseInt(cardNumber.substr(16, 1)) % 2 == 1 ? "male" : "female"; // male,female
        // 设置出生地 省市县
        // this.form.birthdayLocal = getLocation(cardNumber);
      }
    },
    hasFamilyChange(e) {
      if (e === "是") {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
        this.form.familyInfo = [];
      }
    },
    addFamilyMember() {
      console.log("form",this.form);
      const newRow = {
        id: this.form.familyInfo.length + 1,
        isEdit: true,
        sort: this.form.familyInfo.length + 1,
        deptAndHeadship: "",
      };
      this.form.familyInfo.push(newRow);
    },
    delFamily(row) {
      const index = this.form.familyInfo.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.familyInfo.splice(index, 1);
      }
    },
    familyClick(row) {
      this.curFamily = row;
    },
    birthdayDateChange(value) {
      this.form.birthday = value;
    },
    // 保存,投递
    async doSave() {
      // 手动校验，弹出消息以提示
      // if (!this.checkResumeInfo(this.form)) return;

      this.$refs.postForm.validate(async (valid) => {
        if (!valid) return;
        if (!this.childDataCheck(this.form)) {
          return;
        }
        // 保存
        try {
          this.loading = true;
          if (Array.isArray(this.form.placeOfOrigin)) {
            this.form.placeOfOrigin = this.form.placeOfOrigin.join(",")
          }
          if (Array.isArray(this.form.nativePlace)) {
            this.form.nativePlace = this.form.nativePlace.join(",")
          }
          if (Array.isArray(this.form.birthdayLocal)) {
            this.form.birthdayLocal = this.form.birthdayLocal.join(",")
          }
          let res = await saveResumeInfo({
            formData: JSON.stringify(this.form),
            experienceList: JSON.stringify(this.form.experienceList),
            degreeList: JSON.stringify(this.form.degreeList),
            familyInfo: JSON.stringify(this.form.familyInfo),
            practiceLive: JSON.stringify(this.form.parcticeLiveList),
            workLive: JSON.stringify(this.form.workLiveList),
            projectLive: JSON.stringify(this.form.projectLiveList),
            languageInfo: JSON.stringify(this.form.languageInfoList),
            isFirstSave: "yes",
          });
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "保存成功",
              duration: messageDuration,
            });
            // 回填数据
            this.dataToForm(res.data);
          } else {
            this.$message.error(res.data);
          }
        } finally {
          this.loading = false;
        }
      });
    },
    // 表单数据回填
    dataToForm(data) {
      this.form = {...this.form, ...data.formData};
    },
    showContent(){
      this.$refs.showArc.open();
    },
  },
};
</script>
<style scoped>
.tip-class {
  background: #f3f9ff;
  border: 1px solid #69b7ff;
  padding: 10px;
  border-radius: 2px;
  margin: 15px;
}

.icon-color {
  color: #1890ff;
}

.containerInfo {
  background-color: #f6f8f9;
  border-color: #f6f8f9;
}

.avatar {
  width: 300px;
  height: 190px;
  display: block;
}

.avatar-uploader input[type="file"] {
  display: none;
}
</style>
